// extracted by mini-css-extract-plugin
export default {"image-link-card":"image-link-card-8195","image-wrapper":"image-wrapper-3e9d","image":"image-8319","footer":"footer-fa7b"};